import { TAG_CATEGORIES, getCategoriesForType } from '../lib/tagVocabulary'
import type { AssetType } from '../types'

interface Props {
  type: AssetType | null
  selectedTags: string[]
  onToggleTag: (tag: string) => void
  onSingleSelect?: (newTag: string, removeTags: string[]) => void
  compact?: boolean
}

export function TagFilter({ type, selectedTags, onToggleTag, onSingleSelect, compact }: Props) {
  const categories = type ? getCategoriesForType(type) : TAG_CATEGORIES

  const handleClick = (categoryId: string, tagId: string, isMultiSelect: boolean) => {
    const isActive = selectedTags.includes(tagId)

    if (isMultiSelect) {
      onToggleTag(tagId)
      return
    }

    if (isActive) {
      onToggleTag(tagId)
      return
    }

    const cat = categories.find((c) => c.id === categoryId)
    if (!cat) return

    const siblings = cat.values.map((v) => v.id).filter((id) => id !== tagId && selectedTags.includes(id))

    if (siblings.length > 0 && onSingleSelect) {
      onSingleSelect(tagId, siblings)
    } else {
      if (siblings.length > 0) {
        for (const sib of siblings) onToggleTag(sib)
      }
      onToggleTag(tagId)
    }
  }

  return (
    <div className={compact ? 'space-y-1.5' : 'space-y-3'}>
      {categories.map((cat) => (
        <div key={cat.id}>
          <span className="text-[9px] uppercase tracking-wider text-forge-ash font-semibold">
            {cat.label}
            {!cat.multiSelect && (
              <span className="text-forge-cool-smoke ml-1 normal-case">(pick one)</span>
            )}
          </span>
          <div className="flex flex-wrap gap-1 mt-0.5">
            {cat.values.map((v) => {
              const active = selectedTags.includes(v.id)
              return (
                <button
                  key={v.id}
                  onClick={() => handleClick(cat.id, v.id, !!cat.multiSelect)}
                  className={`text-[10px] px-2 py-0.5 rounded-full border transition-colors ${
                    active
                      ? 'border-forge-ember bg-forge-ember/10 text-forge-ember font-semibold'
                      : 'border-forge-slate text-forge-ash hover:border-forge-ember/40 hover:text-forge-secondary'
                  }`}
                >
                  {v.label}
                </button>
              )
            })}
          </div>
        </div>
      ))}
    </div>
  )
}
